const initialState = {
  invCategory: "",
  isTechnicianForm: false,
  multiTech: { workOrderId: [], assignedTo: "" },
  inventoryIds: [],
};
export const workOrder = (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_TECHNICIAN_FORM": {
      return {
        ...state,
        isTechnicianForm: action.payload,
      };
    }
    case "ASSIGN_WO_CATEGORY": {
      return {
        ...state,
        invCategory: action.payload,
      };
    }
    case "ASSIGN_MULTIPLE_TECHNICIAN": {
      return {
        ...state,
        multiTech: action.payload,
      };
    }

    case "ADD_INVENTORY_ID": {
      // Add a selected inventory ID, ensuring it's not already in the list
      return {
        ...state,
        inventoryIds: [...new Set([...state.inventoryIds, action.payload])], // Prevent duplicates
      };
    }
    case "REMOVE_INVENTORY_ID": {
      // Remove a deselected inventory ID
      return {
        ...state,
        inventoryIds: state.inventoryIds.filter(id => id !== action.payload),
      };
    }

    default: {
      return state;
    }
  }
};
